/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ContentFrame from '../../../applicationFrame/ContentFrame';
import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../../components/appNav/AppHeaderScrollable';

import { Card, Spacer, Inputs, Text } from '../../../../bphComponents/bundle';
import ContentWrapper from '../../../components/ContentWrapper';
import ModalWithButtons from '../../../components/modal/ModalWithButtons';
import { ConnectedGrayPrivacyCard } from '../../../components/card/PrivacyCard';
import { PolicyName } from '../../../../models/PolicyModel';

class MfaEnabled extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.loadInitialData();
  }

  render() {
    return (
      <div>
        <ScrollAwareContext>
          <ScrollAwareAppNavStep
            cancel={this.props.goBack}
            color="white"
          />

          <ContentFrame>
            <ScrollAwareScroller>
              <AppHeaderScrollableText
                id="settings2FA.title.text"
              />

              <ContentWrapper>
                <ConnectedGrayPrivacyCard
                  name={PolicyName.MFA_PHONE_NUMBER}
                  subTitle="privacy.privacyBlock.2faPhoneNumber.teaser"
                  onWithdrawConsent={null}
                />

                <Card.CardShape>
                  <Card.CardContent>
                    <Text.TextSubhead className="font-color-gsMedDark">
                      <FormattedMessage id="settings2FA.explanation.message.text" />
                    </Text.TextSubhead>

                    <Spacer.Height18 />

                    <Inputs.TextInput
                      value={this.props.mobileNumber}
                      type="tel"
                      label={<FormattedMessage id="settings2FA.phone.field.label" />}
                      name="mobileNumber"
                      readOnly
                    />

                    <Text.TextFootnote className="font-color-gsMedDark">
                      <FormattedMessage id="settings2FA.countryCode.field.label" /> <span className="font-color-profile"><FormattedMessage id={this.props.countryCodeKey} /></span>
                    </Text.TextFootnote>
                  </Card.CardContent>
                </Card.CardShape>

                <Card.ExternalCardButtonLink onClick={() => this.setState({ showModal: true })}>
                  <FormattedMessage id="settings2FA.disable2FA.button.label" />
                </Card.ExternalCardButtonLink>

                <ModalWithButtons
                  isVisible={this.state.showModal}
                  buttons={[
                    {
                      type: 'primary',
                      action: 'destructive',
                      text: <FormattedMessage id="settings2FA.disable2FAConfirm.button.label" />,
                      onClick: () => {
                        this.props.disableMfa();
                        this.setState({
                          showModal: false,
                        });
                      },
                    },
                    {
                      type: 'secondary',
                      action: 'default',
                      text: <FormattedMessage id="settings2FA.disable2FACancel.button.label" />,
                      onClick: () => {
                        this.setState({
                          showModal: false,
                        });
                      },
                    },
                  ]}
                />
              </ContentWrapper>
            </ScrollAwareScroller>
          </ContentFrame>
        </ScrollAwareContext>
      </div>
    );
  }
}
MfaEnabled.propTypes = {
  isMfaEnabled: PropTypes.bool,
  mobileNumber: PropTypes.string,
  disableMfa: PropTypes.func,
  goBack: PropTypes.func,
  loadInitialData: PropTypes.func,
  countryCodeKey: PropTypes.string,
};

export default MfaEnabled;
